import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  dialogContent: {
    paddingBottom: theme.spacing(3)
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/Login/styles.js